import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { getEmAssignment } from 'redux/reducers/settings/selectors';
import { DeliveryAddressChangedNotice } from '../DeliveryAddressChangedNotice';

export const S10Instructions: FC = () => {
	const emAssignment = useSelector(getEmAssignment);
	const registeredCountryName = emAssignment?.registeredCountryName;

	return (
		<Box sx={{ mt: 2 }}>
			<Typography sx={{ fontSize: '.875rem', fontWeight: 'bold' }}>
				To proceed to the payment please follow the instructions
			</Typography>
			<DeliveryAddressChangedNotice />
			<Typography sx={{ mt: 1.5, fontSize: '.875rem' }}>
				Ship the parcel via {registeredCountryName} Post to:
			</Typography>
			<Box sx={{ mt: 1, fontSize: '.875rem', color: 'text.secondary' }}>
				<Typography sx={{ fontSize: 'inherit' }}>
					Receiver name (Company name): EASY ACCESS SYSTEM EUROPE OÜ
				</Typography>
				<Typography sx={{ fontSize: 'inherit' }}>
					Receiver Address: Mustika postkontor, Karjavälja 4, 12918 Tallinn, Estonia
				</Typography>
				<Typography sx={{ fontSize: 'inherit' }}>Receiver email: omniva@easproject.com</Typography>
				<Typography sx={{ fontSize: 'inherit' }}>Receiver phone: +37256900548</Typography>
			</Box>
			<Typography sx={{ mt: 1.5, fontSize: '.875rem' }}>
				Provide the tracking number (S10 number) found on your shipping label.
			</Typography>
		</Box>
	);
};
